import React, { useState, useEffect } from 'react';
import "./style.css";
import { UnderlinedTitle } from "../UnderlinedTitle";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';

export const CourseLandingWhatsIncluded = (
  { whats_included_list,
    whats_included_images,
    language,
    mobile
  }) => {

  const translations = {
    "es": "¿QUÉ INCLUYE EL PACK?",
    "en": "WHAT'S INCLUDED?",
    "fr": "QU'EST CE QUE CE PACK INCLUS?",
    "pt": "O QUE O PACK INCLUI"
  };

  const [forceUpdateFlag, setForceUpdateFlag] = useState(false);

  useEffect(() => {

    const handleResize = () => {
      // Actualiza el estado para forzar una nueva renderización
      setForceUpdateFlag((prevFlag) => !prevFlag);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }

  }, []);

  return (
    <div className="mt-5 course_landing_whats_included">

      <UnderlinedTitle className="made_outer_sans_regular" text={translations[language]} />

      <div className={(document.body.clientWidth <= 576) ? '' : 'course_landing_whats_included_boxes'}>
        {
          whats_included_list.map((but) => {

            if ((document.body.clientWidth <= 576))
              return (
                <p className="course_landing_whats_included_p" key={but.value.title}>
                  <svg className="" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.81818 7.1194L0.954545 4.29851L0 5.23881L3.81818 9L12 0.940299L11.0455 0L3.81818 7.1194Z" fill="white" />
                  </svg>

                  <span>{but.value.title}</span>
                </p>
              );

            return (
              <div key={but.value.title} className="course_landing_whats_included_box"><span className="course_landing_whats_included_box_text">{but.value.title}</span></div>
            );

          }
          )
        }
      </div>

      {
        (document.body.clientWidth <= 576) ?

          <Swiper
            centeredSlides={false}
            slidesPerView={2}
            observer={false}
            observeParents={false}
            spaceBetween={'10'}
            rewind={false}
            navigation={false}
            pagination={{
              enabled: true,
              clickable: true
            }}
            modules={[Pagination, Navigation]}
            className="course_landing_whats_included_images"
          >

            {
              whats_included_images.map((image) => {

                return (
                <SwiperSlide key={image.image}>
                  <div key={image.title} className="course_landing_whats_included_mobile_image">
                    <img alt={image.title} src={image.image} className="w-100" />
                    <div className="course_landing_whats_included_text">{image.title}</div>
                  </div>
                </SwiperSlide>
                );
              })
            }


          </Swiper>

          :

          <div className="course_landing_whats_included_images row gy-4">

            {
              whats_included_images.map((image) => {

                return (
                  <div key={image.title} className="col-sm-4">
                    <img alt={image.title} src={image.image} className="w-100" />
                    <div className="course_landing_whats_included_text">{image.title}</div>
                  </div>
                );

              }
              )
            }

          </div>
      }

    </div>
  );
};
